import {Component, OnInit} from '@angular/core';
import {QuestionOptions} from '../../../constants/question-options';
import {User} from '../../../model/user';
import {FormBuilder, Validators} from '@angular/forms';
import {UserFormBase} from '../user-form-base/user-form-base.component';
import {CustomValidators} from '../../../validator/custom-validator';
import {UserService} from '../../../services/user/user.service';
import {take} from 'rxjs';
import {AuthService} from '../../../services/auth/auth.service';

@Component({
    selector: 'app-personal-information-form',
    templateUrl: './personal-information-form.component.html',
    styleUrls: ['../../../../styles/form-input.scss'],
    providers: [{ provide: UserFormBase, useExisting: PersonalInformationFormComponent }],
    standalone: false
})
export class PersonalInformationFormComponent extends UserFormBase implements OnInit{
  QuestionOptions = QuestionOptions;

  constructor(private readonly fb: FormBuilder,
              private readonly userService: UserService,
              private readonly authService: AuthService) {
    super();
  }

  formGroup = this.fb.group({
    firstName: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    lastName: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    email: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
  });

  ngOnInit(): void {
    this.userService.getUserInfoFromKeycloak(this.authService.getUserIdFromAccessToken()).pipe(take(1)).subscribe(
      user=> this.formGroup.patchValue({firstName: user.firstName, lastName: user.lastName, email: user.email})
    );
  }

  updateUser(user: User): void {
    user.firstName = this.formGroup.value.firstName;
    user.lastName = this.formGroup.value.lastName;
    user.email = this.formGroup.value.email;
  }


}
